<div class="app-header">
  <button class="hamburger-btn" (click)="toggleMenu()">
    <i class="material-icons">menu</i>
  </button>
  <div class="header-right-content">
    <div class="user-profile" dropdown>
      <div class="user-info-trigger" dropdownToggle>
        <div class="user-avatar" [style.background-image]="avatarUrl">
          {{ getInitials(loggedUser?.name) }}
        </div>
        <div class="user-details">
          <span class="user-name">{{ loggedUser?.name }}</span>
        </div>
        <i class="material-icons chevron">keyboard_arrow_down</i>
      </div>

      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
        <!-- !TODO: Comentado para ser implementado depois.
          <li class="dropdown-header">
            <strong>{{ loggedUser?.organizacoes?.[0]?.name }}</strong> 
          </li>
          <li class="divider dropdown-divider"></li>
        -->
        <li>
          <a class="dropdown-item" (click)="logout()">
            <i class="material-icons">exit_to_app</i> Sair
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>